import { ReactNode } from 'react'

import { B2B_EMAIL } from './b2b.constants'

// Error strings may wrap the "contact us" label in `<contact>…</contact>` (see
// `max_per_size_contact_error`); render that label as a mailto link to the B2B concierge.
const CONTACT_TAG_OPEN = '<contact>'
const CONTACT_TAG_CLOSE = '</contact>'

/** Renders B2B error copy; a complete `<contact>…</contact>` token becomes a mailto link. */
export function renderB2bInlineErrorMessage(message: string | undefined, contactLinkClassName: string): ReactNode {
  if (!message) return message

  const contactOpenIndex = message.indexOf(CONTACT_TAG_OPEN)
  const contactCloseIndex = message.indexOf(CONTACT_TAG_CLOSE)
  if (contactOpenIndex !== -1 && contactCloseIndex > contactOpenIndex) {
    return (
      <>
        {message.slice(0, contactOpenIndex)}
        <a className={contactLinkClassName} href={`mailto:${B2B_EMAIL}`}>
          {message.slice(contactOpenIndex + CONTACT_TAG_OPEN.length, contactCloseIndex)}
        </a>
        {message.slice(contactCloseIndex + CONTACT_TAG_CLOSE.length)}
      </>
    )
  }

  return message
}
